import { canAccessScreen } from "@/utils/postLoginNavigation";

/** nome_tela do relatório Histórico de rotas (RELHistoricoRotas.vue), que tem as abas Linhas e Unidades. */
export const TELA_HISTORICO_ROTAS_OTIMIZADAS = "RELHistoricoRotas";

function leSessao(chave, padrao) {
  try {
    const raw = sessionStorage.getItem(chave);
    return raw ? JSON.parse(raw) : padrao;
  } catch (e) {
    return padrao;
  }
}

/** Botão "Histórico" das abas Comparação: só para quem pode abrir o relatório. */
export function podeVerHistoricoRotasOtimizadas() {
  return canAccessScreen(leSessao("user", null), leSessao("permissoes", []), TELA_HISTORICO_ROTAS_OTIMIZADAS);
}

/** Rota do relatório já filtrado por linha ou unidade (`tipo`) e sentido. */
export function rotaHistoricoRotasOtimizadas(tipo, id, idSentido) {
  const query = { tipo, id: String(id) };
  if (idSentido != null) query.sentido = String(idSentido);
  return { path: "/relhistoricorotas", query };
}
